import { jsx as n } from "react/jsx-runtime";
import { useMemo as B } from "react";
import { a as V } from "../../core-DVmjA3_O.js";
import "../../type-Dku6Xzl6.js";
import g from "../ButtonLayout/index.js";
import P from "../RawButton/index.js";
import '../../index13.css';const R = "_button_qth5l_1", _ = {
  button: R
};
function C(e) {
  const {
    colorVariant: o,
    styleVariant: t = "outline",
    spacing: a,
    spacingOffset: i = -3,
    withoutPadding: s,
    withFullWidth: u,
    before: l,
    after: m,
    textSize: c,
    layoutElementRef: f,
    name: p,
    onClick: d,
    children: b,
    disabled: r,
    className: h,
    type: y = "button",
    ...w
  } = e, x = B(() => V(o) ? o : t === "action" || t === "transparent" ? "text" : "primary", [t, o]);
  return /* @__PURE__ */ n(
    P,
    {
      ...w,
      className: _.button,
      name: p,
      onClick: d,
      type: y,
      disabled: r,
      children: /* @__PURE__ */ n(
        g,
        {
          className: h,
          elementRef: f,
          colorVariant: x,
          styleVariant: t,
          spacing: a,
          spacingOffset: i,
          withoutPadding: s,
          withFullWidth: u,
          before: l,
          after: m,
          textSize: c,
          disabled: r,
          children: b
        }
      )
    }
  );
}
export {
  C as default
};
